import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { BookingProvider } from './context/BookingContext';
import Header from './components/Header';
import Home from './pages/Home';
import Explore from './pages/Explore';
import ShopDetail from './pages/ShopDetail';
import Booking from './pages/Booking';
import Checkout from './pages/Checkout';
import MyBookings from './pages/MyBookings';
import Auth from './pages/Auth';

function App() {
  return (
    <AuthProvider>
      <BookingProvider>
        <Router>
          <div className="min-h-screen bg-prim-background">
            <Routes>
              {/* Auth Route - No Header */}
              <Route path="/auth" element={<Auth />} />
              
              {/* Routes with Header */}
              <Route
                path="/*"
                element={
                  <>
                    <Header />
                    <Routes>
                      <Route path="/" element={<Home />} />
                      <Route path="/explore" element={<Explore />} />
                      <Route path="/shop/:businessId" element={<ShopDetail />} />
                      <Route path="/booking/:businessId" element={<Booking />} />
                      <Route path="/checkout/:businessId" element={<Checkout />} />
                      <Route path="/bookings" element={<MyBookings />} />
                    </Routes>
                  </>
                }
              />
            </Routes>
          </div>
        </Router>
      </BookingProvider>
    </AuthProvider>
  );
}

export default App;
